export default __webpack_public_path__ + "static/media/ba20.28873e15.jpg";